import Layout from "../Layout";
import React, { useContext } from "react";
import { lazy, Suspense } from "react";
import UserContext from "../context/UserContext";
import Loader from "../components/Notifications/Loader";

const SuperAdminDashboard = lazy(() => import("./SuperAdminRole/Dashboard"));
const AdminDashboard = lazy(() => import("./AdminRole/Dashboard"));
const FinanceDashboard = lazy(() => import("./FinanceRole/Dashboard"));
const DoctorDashboard = lazy(() => import("./DoctorRole/Dashboard"));
const ReceptionDashboard = lazy(() => import("./ReceptionistRole/Dashboard"));
const DefaultDashboard = lazy(() => import("./DefaultDashboard"));

function Dashboard() {
  const { user } = useContext(UserContext);
  const userRole = user?.role;

  const renderDashboard = () => {
    switch (userRole) {
      case "superadmin":
        return <SuperAdminDashboard />;
      case "admin":
        return <AdminDashboard />;
      case "doctor":
        return <DoctorDashboard />;
      case "reception":
        return <ReceptionDashboard />;
      case "finance":
        return <FinanceDashboard />;
      default:
        return <DefaultDashboard />;
    }
  };

  return (
    <Suspense fallback={<Loader />}>
      <Layout>{renderDashboard()}</Layout>
    </Suspense>
  );
}

export default Dashboard;
